export class AuthRoutingPath {
  static readonly AUTH_CONFIRM_ACCOUNT = 'confirm-account/:token';
  static readonly AUTH_CONFIRM_CHANGE_BUSINESS_UNIT =
    'confirm-change-business-unit/:token';
  static readonly AUTH_FORGET_PASSWORD = 'forget-password';
  static readonly AUTH_LOGIN = 'login';
  static readonly AUTH_ACTIVATE_USER = 'activate-user';
  static readonly AUTH = 'auth';
}
